import { useMutation, useQuery } from 'react-query';
import { toast } from 'react-toastify';
import { queryClient } from 'index';
import { ReactQueryKeys } from 'services/api/reactQueryKeys';
import { getToastErrorMessage, LogyxError } from 'services/api/errors';
import { ReactMutationKeys } from 'services/api/reactMutationKeys';
import { getCompany, updateCompany } from 'services/CompanyService';
import { useTranslation } from 'react-i18next';
import { IEditCompanyDataDTO } from './types';

export const useGetCompany = (companyId: number) => {
  return useQuery({
    queryKey: [ReactQueryKeys.GET_COMPANY, companyId],
    queryFn: () => {
      return getCompany(companyId);
    },
  });
};

export const useEditCompany = (companyId: number) => {
  const { t } = useTranslation();
  return useMutation(
    (editCompanyDTO: Partial<IEditCompanyDataDTO>) =>
      updateCompany(companyId, editCompanyDTO),
    {
      onSuccess: () => {
        toast.success(t('Company configuration edited'), {
          className: ReactMutationKeys.UPDATE_COMPANY_SETTINGS,
        });
        queryClient.invalidateQueries([ReactQueryKeys.GET_COMPANY]);
        queryClient.invalidateQueries([ReactQueryKeys.GET_SHOPPING_CART]);
      },
      onError: (error: LogyxError) => {
        toast.error(getToastErrorMessage(error), {
          toastId: ReactMutationKeys.UPDATE_COMPANY_SETTINGS,
        });
      },
      mutationKey: ReactMutationKeys.UPDATE_COMPANY_SETTINGS,
    }
  );
};
